<template>
  <div v-if="hasAQSIRight" class="mb-3">
    <b-button class="btn-collapse" v-spaceduck-collapse="`collapse-aqsi`">AQSI</b-button>
    <spaceduck-collapse id="collapse-aqsi">
      <div class="pt-4">
        <div v-for="(a, aind) in aqsi.aqsi_key" :key="`k-${aind}`">
          <div class="row align-items-center">
            <div class="col">
              <InputGroup v-model="aqsi.aqsi_key[aind].title"
                          class="mb-3"
                          :label="$t('title')"/>
            </div>
            <div class="col">
              <InputGroup v-model="aqsi.aqsi_key[aind].key"
                          class="mb-3"
                          :label="$t('integration_key')"/>
            </div>
            <div class="col col-auto">
              <a class="pointer" @click="removeKey(aind)"><DeleteSvg class="svg-stroke-light"/></a>
            </div>
          </div>
        </div>
        <div class="text-right">
          <a class="btn btn-themed btn-themed-outline btn-themed-squared" @click="addKey"><PlusSvg/></a>
        </div>

        <div>
          <CheckboxGroup :label="$t('send_services_in_cheque')"
                         fid="send_services"
                         class="mt-3"
                         :checkboxvalue="1"
                         v-model="aqsi.aqsi_send_services"/>
          <SelectGroup :options="aqsiTaxModes"
                       :label="$t('vat_rate')"
                       class="mt-3"
                       variant="white"
                       :showlabel="true"
                       v-model="aqsi.aqsi_tax"/>
          <ServiceMultiSelect :label="$t('pay_methods_cash')"
                              :dblclick="false"
                              v-if="loaded"
                              model="pay_method"
                              title="translatedTitle"
                              class="mt-3"
                              :dbsearch="false"
                              :prepopulatedOptions="pay_methods"
                              v-model="aqsi.aqsi_cashmethods"/>
        </div>

        <div class="mt-4">
          <button class="btn btn-themed btn-themed-squared"
                  :disabled="loading"
                  @click="save">
            {{ $t('save') }}
          </button>
        </div>
      </div>
    </spaceduck-collapse>
  </div>
</template>

<script>
import { ClinicService } from "@/services/api/clinic.api.service"
import {mapGetters, mapState} from "vuex"
import InputGroup from "@/components/form/InputGroup.vue"
import PlusSvg from '@/assets/svg-vue/patients/plus_tag.svg'
import DeleteSvg from '@/assets/svg-vue/general/delete2.svg'
import CheckboxGroup from "@/components/form/CheckboxGroup.vue"
import SelectGroup from "@/components/form/SelectGroup.vue"
import { aqsiTaxModes } from "@/dictionaries/dictionary"
import ServiceMultiSelect from "@/components/form/ServiceMultiSelect.vue"
import SpaceduckCollapse from "@/components/parts/general/SpaceduckCollapse.vue"

export default {
  name: "AQSIIntegration",
  emits: ['update'],
  components: {
    SpaceduckCollapse,
    ServiceMultiSelect,
    SelectGroup,
    CheckboxGroup,
    InputGroup,
    PlusSvg,
    DeleteSvg
  },
  computed: {
    ...mapState({
      clinic: state   => state.auth.clinic,
      superadmin: state => state.auth.superadmin,
      rights: state => state.auth.rights,
      loading: state => state.dom.loading,
      ppoData: state => state.ppo.ppoData,
      pay_methods: state => state.auth.pay_methods,
      branch: state => state.auth.branch
    }),
    ...mapGetters([
      'dynamicConfigValue'
    ]),
    hasAQSIRight() {
      return this.rights.includes('aqsi')
    }
  },
  data() {
    return {
      loaded: false,
      aqsi: {
        aqsi_key: [{key: '', title: ''}],
        aqsi_send_services: 0,
        aqsi_tax: 6,
        aqsi_cashmethods: [],
      },
      aqsiTaxModes
    }
  },
  methods: {
    async save() {
      await ClinicService.saveDynamicConfigs([
        {
          id: 'aqsi_key',
          value: this.aqsi.aqsi_key,
          subgroup: 'aqsi',
          branchId: this.branch
        },
        {
          id: 'aqsi_send_services',
          value: this.aqsi.aqsi_send_services,
          subgroup: 'aqsi'
        },
        {
          id: 'aqsi_tax',
          value: this.aqsi.aqsi_tax,
          subgroup: 'aqsi'
        },
        {
          id: 'aqsi_cashmethods',
          value: this.aqsi.aqsi_cashmethods.map(x => x.id),
          subgroup: 'aqsi',
          branchId: this.branch
        },
      ], this.superadmin, this.clinic.id)
      this.$noty.info(this.$t('success_message'))
      this.$emit('update')
    },
    addKey() {
      this.aqsi.aqsi_key.push({key: '', title: ''})
    },
    removeKey(index) {
      this.aqsi.aqsi_key.splice(index, 1)
    }
  },
  async mounted() {
    this.aqsi.aqsi_key = this.dynamicConfigValue('aqsi_key', this.branch) || [{key: '', title: ''}]
    this.aqsi.aqsi_send_services = this.dynamicConfigValue('aqsi_send_services')
    this.aqsi.aqsi_tax = this.dynamicConfigValue('aqsi_tax')
    this.aqsi.aqsi_cashmethods = []
    let cashMethods = this.dynamicConfigValue('aqsi_cashmethods', this.branch)
    if(cashMethods) {
      this.aqsi.aqsi_cashmethods = this.pay_methods.filter(p => cashMethods.includes(p.id))
    }
    this.loaded = true
  }
}
</script>
